/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_NewInputs */

const en_directory_launch_new = /** @type {(inputs: Directory_Launch_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const zh_directory_launch_new = /** @type {(inputs: Directory_Launch_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新收录`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Directory_Launch_NewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_new = /** @type {((inputs?: Directory_Launch_NewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_NewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_new(inputs)
	return zh_directory_launch_new(inputs)
});
export { directory_launch_new as "directory.launch.new" }